/* PCS Header v2 — 25-9-2026: sticky compact bar, mega menus with hover intent + keyboard, mobile drawer, predictive search.
   27-9-2026: compact-on-scroll now uses hysteresis (on above 140px, off below 20px), rAF throttling and
   overflow-anchor:none, so the ~23px height change can no longer flip the state back and forth (header shake). */
(function () {
  'use strict';
  var wrapper = document.querySelector('.pcs-header-wrapper');
  if (!wrapper) return;
  wrapper.classList.add('pcs-js');

  /* ---------- sticky compact ---------- */
  var sticky = document.getElementById('pcs-header-sticky');
  var util = wrapper.querySelector('.pcs-header-util');
  function setUtilOffset() {
    var h = util ? util.offsetHeight : 0;
    wrapper.style.setProperty('--pcs-util-h', (0 - h) + 'px');
  }
  setUtilOffset();
  window.addEventListener('resize', setUtilOffset);
  /* --pcs-sticky-h = height of the part of the header that stays on screen; other sections
     (collection filter sidebar, anchors) use it for their sticky offsets. */
  function setStickyHeight() {
    var h = sticky ? sticky.offsetHeight : wrapper.offsetHeight;
    document.documentElement.style.setProperty('--pcs-sticky-h', h + 'px');
  }
  setStickyHeight();
  window.addEventListener('resize', setStickyHeight);
  if (sticky) {
    /* the browser must not re-anchor the scroll position when the header shrinks/grows */
    wrapper.style.overflowAnchor = 'none';
    var ON_AT = 140, OFF_AT = 20;
    var compact = false, ticking = false, heightTimer = null;
    var update = function () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      var next = compact ? y > OFF_AT : y > ON_AT;
      if (next !== compact) {
        compact = next;
        sticky.classList.toggle('is-compact', next);
        clearTimeout(heightTimer);
        heightTimer = setTimeout(setStickyHeight, 300);
      }
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------- mega menus ---------- */
  var items = Array.prototype.slice.call(wrapper.querySelectorAll('[data-pcs-menu-item]'));
  var backdrop = wrapper.querySelector('[data-pcs-backdrop]');
  var openTimer = null, closeTimer = null, current = null;
  var isTouch = window.matchMedia('(hover: none)').matches;

  function setOpen(item, open) {
    if (!item) return;
    item.classList.toggle('is-open', open);
    var trig = item.querySelector('[data-pcs-menu-trigger]');
    if (trig) trig.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll() {
    items.forEach(function (it) { setOpen(it, false); });
    current = null;
    if (backdrop) backdrop.classList.remove('is-visible');
  }
  function openItem(item) {
    if (current && current !== item) setOpen(current, false);
    setOpen(item, true);
    current = item;
    if (backdrop) backdrop.classList.add('is-visible');
  }

  items.forEach(function (item) {
    var trig = item.querySelector('[data-pcs-menu-trigger]');
    if (!trig) return;
    item.addEventListener('mouseenter', function () {
      if (isTouch) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openItem(item); }, current ? 0 : 90);
    });
    item.addEventListener('mouseleave', function () {
      if (isTouch) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { if (current === item) closeAll(); }, 160);
    });
    trig.addEventListener('click', function (e) {
      var isButton = trig.tagName === 'BUTTON';
      if (isButton || isTouch) {
        if (isButton || !item.classList.contains('is-open')) {
          e.preventDefault();
          if (item.classList.contains('is-open')) closeAll(); else openItem(item);
        }
      }
    });
    trig.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && trig.tagName === 'BUTTON')) {
        e.preventDefault();
        openItem(item);
        var first = item.querySelector('[data-pcs-menu-panel] a');
        if (first) first.focus();
      }
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) setOpen(item, false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (current) { var t = current.querySelector('[data-pcs-menu-trigger]'); closeAll(); if (t) t.focus(); }
      closeDrawer();
      hideResults();
    }
  });
  document.addEventListener('click', function (e) {
    if (current && !current.contains(e.target)) closeAll();
  });
  if (backdrop) backdrop.addEventListener('mouseenter', closeAll);

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('pcs-mobile-nav');
  var openBtn = wrapper.querySelector('[data-pcs-open-drawer]');
  var drawerScrollY = 0;
  function focusables() {
    if (!drawer) return [];
    return Array.prototype.filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]'), function (el) {
      return el.offsetParent !== null;
    });
  }
  function openDrawer() {
    if (!drawer) return;
    drawerScrollY = window.scrollY;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pcs-nav-open');
    document.body.style.top = (0 - drawerScrollY) + 'px';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var c = drawer.querySelector('[data-pcs-close-drawer]');
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pcs-nav-open');
    document.body.style.top = '';
    try { window.scrollTo({ top: drawerScrollY, left: 0, behavior: 'instant' }); } catch (err) { window.scrollTo(0, drawerScrollY); }
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (drawer) drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  Array.prototype.forEach.call(wrapper.querySelectorAll('[data-pcs-close-drawer]'), function (el) {
    el.addEventListener('click', closeDrawer);
  });
  Array.prototype.forEach.call(wrapper.querySelectorAll('[data-pcs-accordion]'), function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.closest('.pcs-mobile-nav__item');
      var open = li.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- cart count (keeps in sync with theme cart events) ---------- */
  var countEl = wrapper.querySelector('[data-pcs-cart-count]');
  function refreshCart() {
    if (!countEl) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      countEl.textContent = c.item_count;
      countEl.classList.toggle('is-empty', !c.item_count);
    }).catch(function () {});
  }
  ['cart:update', 'cart:refresh', 'cart:change', 'CartUpdateEvent', 'cart-update'].forEach(function (ev) {
    document.addEventListener(ev, refreshCart);
  });

  /* ---------- predictive search ---------- */
  var box = wrapper.querySelector('[data-pcs-search]');
  if (!box) return;
  var input = box.querySelector('[data-pcs-search-input]');
  var results = box.querySelector('[data-pcs-search-results]');
  var clearBtn = box.querySelector('[data-pcs-search-clear]');
  var moneyFmt = box.getAttribute('data-money-format') || '£' + '{' + '{amount}' + '}';
  var searchUrl = box.getAttribute('data-search-url') || '/search';
  var suggestUrl = box.getAttribute('data-suggest-url') || '/search/suggest';
  var cache = {}, controller = null, debounce = null, focusIdx = -1, lastQuery = '';

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var s = n.toFixed(2);
    var parts = s.split('.');
    var whole = parts[0], out = '';
    while (whole.length > 3) { out = ',' + whole.slice(-3) + out; whole = whole.slice(0, -3); }
    var amount = whole + out + '.' + parts[1];
    var noDec = whole + out;
    var f = moneyFmt;
    f = f.split('{' + '{amount}' + '}').join(amount);
    f = f.split('{' + '{amount_no_decimals}' + '}').join(noDec);
    f = f.split('{' + '{amount_with_comma_separator}' + '}').join(amount.split('.').join(','));
    return f;
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function highlight(title, q) {
    var t = esc(title), i = t.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return t;
    return t.slice(0, i) + '<mark>' + t.slice(i, i + q.length) + '</mark>' + t.slice(i + q.length);
  }
  function hideResults() {
    if (!results) return;
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    focusIdx = -1;
  }
  function showResults(html) {
    results.innerHTML = html;
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    focusIdx = -1;
  }
  function imgUrl(u, size) {
    if (!u) return '';
    var q = u.indexOf('?');
    var base = q > -1 ? u.slice(0, q) : u;
    return base + '?width=' + size;
  }
  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [], collections = r.collections || [];
    if (!products.length && !collections.length) {
      showResults('<div class="pcs-sr__empty">No matches for &ldquo;' + esc(q) + '&rdquo; &mdash; try a shorter word, or press Enter to search everything.</div>');
      return;
    }
    var html = '';
    if (collections.length) {
      html += '<div class="pcs-sr__group"><div class="pcs-sr__label">Categories</div><div class="pcs-sr__chips">';
      collections.forEach(function (c) {
        html += '<a class="pcs-sr__chip" role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
      });
      html += '</div></div>';
    }
    if (products.length) {
      html += '<div class="pcs-sr__group"><div class="pcs-sr__label">Products</div>';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(imgUrl(p.featured_image.url, 96)) + '" alt="" loading="lazy" width="48" height="48">' : '';
        var meta = p.product_type ? esc(p.product_type) : '';
        html += '<a class="pcs-sr__item" role="option" href="' + esc(p.url) + '">' +
          '<span class="pcs-sr__img">' + img + '</span>' +
          '<span class="pcs-sr__text"><span class="pcs-sr__title">' + highlight(p.title, q) + '</span>' +
          (meta ? '<span class="pcs-sr__meta">' + meta + '</span>' : '') + '</span>' +
          '<span class="pcs-sr__price">' + esc(money(p.price)) + '</span></a>';
      });
      html += '</div>';
    }
    html += '<a class="pcs-sr__all" role="option" href="' + esc(searchUrl) + '?type=product&q=' + encodeURIComponent(q) + '"><span>See all results for &ldquo;' + esc(q) + '&rdquo;</span><span>&rarr;</span></a>';
    showResults(html);
  }
  function fetchSuggest(q) {
    if (cache[q]) { render(cache[q], q); return; }
    if (controller) controller.abort();
    controller = new AbortController();
    var url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku';
    fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cache[q] = data;
        if (input.value.trim() === q) render(data, q);
      })
      .catch(function () {});
  }
  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = !q;
    clearTimeout(debounce);
    if (q.length < 2) { hideResults(); return; }
    debounce = setTimeout(function () { lastQuery = q; fetchSuggest(q); }, 220);
  });
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && results.innerHTML) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    if (window.matchMedia('(max-width: 900px)').matches) {
      setTimeout(function () { try { wrapper.scrollIntoView({ block: 'start' }); } catch (err) {} }, 250);
    }
  });
  input.addEventListener('keydown', function (e) {
    if (results.hidden) return;
    var opts = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    if (!opts.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      focusIdx = e.key === 'ArrowDown' ? Math.min(focusIdx + 1, opts.length - 1) : Math.max(focusIdx - 1, 0);
      opts.forEach(function (o, i) { o.classList.toggle('is-focus', i === focusIdx); });
      opts[focusIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && focusIdx > -1) {
      e.preventDefault();
      window.location.href = opts[focusIdx].getAttribute('href');
    }
  });
  if (clearBtn) clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    hideResults();
    input.focus();
  });
  document.addEventListener('click', function (e) {
    if (!box.contains(e.target)) hideResults();
  });
})();